import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
// import "../scss/postActions.scss";

const PostActions = ({ 
    isLiked, 
    likeCount, 
    onLike, 
    onCommentClick, 
    onShareClick, 
    onTipClick, 
    isLoading,
    isTipping, 
    commentCount, 
    hasWallet 
}) => {
    return (
        <div className="infor">
            <div className="item">
                {isLoading 
                ?  "..." : 
                    isLiked ? 
                (
                    <FavoriteOutlinedIcon 
                        style={{ color: "red" }} 
                        onClick={onLike} 
                    />
                ) : (
                    <FavoriteBorderOutlinedIcon onClick={onLike} />
                )}
                {likeCount} Likes
            </div>

            <div className="item" onClick={onCommentClick}>
                <TextsmsOutlinedIcon /> {commentCount} Comments
            </div>

            <div className="item" onClick={onShareClick}>
                <ShareOutlinedIcon /> Share
            </div>
    
            <div
                className={`item tip-btn ${hasWallet ? "has-wallet" : "no-wallet"} ${isTipping ? "is-tipping" : ""}`}
                onClick={(hasWallet && !isTipping) ? onTipClick : undefined}
            >
                <PaidOutlinedIcon />
                {isTipping ? "Processing..." : "Tip"}
            </div>
        </div>
    );
};
export default PostActions;